// src/components/Header.js
import LogoutButton from '../components/LogoutButton';
import { Stack, Typography } from '@mui/material';
import { AccountCircle, PhoneAndroid } from '@mui/icons-material';

const Header = ({ userName, deviceName }) => {
  return (
    <header>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mx={2} mt={2}
      >
        <Stack direction="row" spacing={3} alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center">
            <AccountCircle color="primary" sx={{ fontSize: 30 }} />
            <Typography variant="body1">
              {userName}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <PhoneAndroid color="primary" sx={{ fontSize: 30 }} />
            <Typography variant="body1">
              {deviceName}
            </Typography>
          </Stack>
        </Stack>

        <LogoutButton />
      </Stack>
    </header>
  );
};

export default Header;
